/* SASHA'S — Judge.me review-photo upscaler (2026-08-25, Jarvis)
   The 8-25 Amazon import carried 88px `_SY88` thumbnails; Judge.me copied
   those tiny files to its CDN, so the lightbox blew up an 88px image.
   The Amazon image ID survives in Judge.me's CDN filename, but with `+`
   munged to `-` — so the map below (generated from the import CSV,
   every entry HEAD-verified 200 on 2026-08-25) restores the true ID.
   On lightbox open we swap to Amazon's _SL1600_ original; on any failure
   the CDN copy stays. 2026-08-27: thumbnails get the same treatment at a
   size matched to their box (_SL320_/480_/640_), because an 88px file
   stretched into a 100-160px box read as blurry. */
(function () {
  var MAP = {"81uIsXo1ecL":"81uIsXo1ecL","818TU7xPabL":"818TU7xPabL","81lq2e7fXxL":"81lq2e7fXxL","71L639tZobL":"71L639tZobL","710vfy5qvuL":"710vfy5qvuL","8126ITRTRCL":"8126ITRTRCL","81DM8ea8jHL":"81DM8ea8jHL","814mmYzjtaL":"814mmYzjtaL","71p5y7ZKw-L":"71p5y7ZKw+L","81cRtvD-ZrL":"81cRtvD-ZrL","71zSJHfl-LL":"71zSJHfl+LL","713tI8vzjiL":"713tI8vzjiL","81dYMhCKugL":"81dYMhCKugL","81e08RmrOyL":"81e08RmrOyL","71ACXNGQAbL":"71ACXNGQAbL","812o-Lix6CL":"812o+Lix6CL","812483rHCIL":"812483rHCIL","61-uwyUW-HL":"61+uwyUW-HL","81YKDvusITL":"81YKDvusITL","81ixUKXzGuL":"81ixUKXzGuL","61qqYXR05SL":"61qqYXR05SL","81Souw6T1VL":"81Souw6T1VL","81LiN6U1tyL":"81LiN6U1tyL","81HjIWwO0eL":"81HjIWwO0eL","71Un5Z7ysQL":"71Un5Z7ysQL","71iKgOHAz7L":"71iKgOHAz7L","71P9WneD5hL":"71P9WneD5hL","71D4q-je3wL":"71D4q-je3wL","71PA-eco-lL":"71PA+eco-lL","71ivWR9CWdL":"71ivWR9CWdL","61annN4QDPL":"61annN4QDPL","71Hv55JblQL":"71Hv55JblQL","616gDfDQyWL":"616gDfDQyWL","81tdVPpGynL":"81tdVPpGynL","612wOnbuzPL":"612wOnbuzPL","61aXjbQJvEL":"61aXjbQJvEL","61MDa1lP1IL":"61MDa1lP1IL","81Tnp-rWtML":"81Tnp+rWtML","91bWvNaXNCL":"91bWvNaXNCL","81dQGrcVcVL":"81dQGrcVcVL","71N9gpQ4UXL":"71N9gpQ4UXL","81sYyXzus5L":"81sYyXzus5L","81wtN6SR5uL":"81wtN6SR5uL","81btx9ECAxL":"81btx9ECAxL","61OEZ4bkAtL":"61OEZ4bkAtL","71TetSzaeEL":"71TetSzaeEL","719rUMUFhyL":"719rUMUFhyL","81BwmWrLDnL":"81BwmWrLDnL","810EFjyW7PL":"810EFjyW7PL","81d4N-rgStL":"81d4N-rgStL","81nnCzQ82vL":"81nnCzQ82vL","81jkwijzkAL":"81jkwijzkAL","81267nvDm3L":"81267nvDm3L","81ykrKbFPGL":"81ykrKbFPGL","71XDOmoZ--L":"71XDOmoZ-+L","81nSdFSFqjL":"81nSdFSFqjL","71koyEOPwYL":"71koyEOPwYL","710bVzWmcLL":"710bVzWmcLL","71J3FzbUzbL":"71J3FzbUzbL","816f0xJrmdL":"816f0xJrmdL","817kQ0L8FoL":"817kQ0L8FoL","81ZXhiKOduL":"81ZXhiKOduL","81T-Xdc-BtL":"81T+Xdc+BtL","B1qgptXyNBS":"B1qgptXyNBS","B16KxlunoCS":"B16KxlunoCS","B1rUd4nW0tS":"B1rUd4nW0tS","B1d0iDF2LaS":"B1d0iDF2LaS","91n-vD14XoL":"91n-vD14XoL","71Zo05M40xL":"71Zo05M40xL","71bm2h3iu1L":"71bm2h3iu1L","712yASJazFL":"712yASJazFL","71JwHQCMO2L":"71JwHQCMO2L","61qtEVrvebL":"61qtEVrvebL","51FqY19ggHL":"51FqY19ggHL","71dVRiJ0gtL":"71dVRiJ0gtL","71gaAMMYIwL":"71gaAMMYIwL","71gLmA2OtYL":"71gLmA2OtYL","81veXalFqDL":"81veXalFqDL","81ludbkPX0L":"81ludbkPX0L","81fR--hhJyL":"81fR-+hhJyL","81EklB5peSL":"81EklB5peSL","81cBlLJQ8RL":"81cBlLJQ8RL","81Qiu-goLOL":"81Qiu+goLOL","81yM9lIJtFL":"81yM9lIJtFL","61G84Zvn5nL":"61G84Zvn5nL","8177-7uDrfL":"8177-7uDrfL","71c9a1ZekZL":"71c9a1ZekZL","81y22RcxJzL":"81y22RcxJzL","61mAsla3aUL":"61mAsla3aUL","71UyU0bkQjL":"71UyU0bkQjL","91WFEz4X1OL":"91WFEz4X1OL","81okv2LlB-L":"81okv2LlB+L","81jtrkYHTVL":"81jtrkYHTVL","81XG9kg046L":"81XG9kg046L","A1iuLckKnRL":"A1iuLckKnRL","91l0YW34LiL":"91l0YW34LiL","71YUwX3m7NL":"71YUwX3m7NL","71kngAXFEbL":"71kngAXFEbL","71O49JCijoL":"71O49JCijoL","710uoZn2ArL":"710uoZn2ArL","71KLW448oFL":"71KLW448oFL","81lvcXH5BVL":"81lvcXH5BVL","71XMZqi8kSL":"71XMZqi8kSL","71s3frAHYdL":"71s3frAHYdL","711iJLeDd6L":"711iJLeDd6L","71q9LGe6x5L":"71q9LGe6x5L","71o3T-gGpXL":"71o3T-gGpXL","71D747XrsRL":"71D747XrsRL","71AuBoeAhgL":"71AuBoeAhgL","716O5lpfYzL":"716O5lpfYzL","710nzVqvz3L":"710nzVqvz3L","61TgSYMRYQL":"61TgSYMRYQL","71Iceb3CtzL":"71Iceb3CtzL","71eygTksomL":"71eygTksomL","71DQuhSdjzL":"71DQuhSdjzL","61FidiQdNKL":"61FidiQdNKL"};
  var AMZ_ID = /__([A-Za-z0-9%+.-]+?)\._S[XY]\d+__/;

  /* --- Photo removals (2026-08-26, Jack's cull of old-product photos) ---
     32 pictures pulled from display: product was redesigned, these photos
     show the old version. Review text/stars stay. Stems are the unique
     ts__idx__rand prefix of Judge.me's CDN filename (per-picture unique).
     Judge.me's API ignores picture edits (tested 8-26), so this storefront
     layer is the enforcement point. Master list + review mapping:
     sashas/reviews/photo-curation-map_2026-08-26.json */
  var REMOVED = ["1787653572__0__SgWMRhYl","1787653585__2__yPOIdEMh","1787653585__1__7tE9k--U","1787653585__0__lwKaZ-eb","1787653570__0__tvdZS7TU","1787653569__0__CDg_ATFw","1787653569__0__BQA13HjV","1787653569__1__88A4PBRG","1787653589__3__E9AkjARF","1787653589__0__B3oQBZGW","1787653589__1__3ijw2LuV","1787653589__2__1OAFjCWb","1787653581__1__AJ648rSs","1787653582__2__WOovp4Tm","1787653577__1__GF867jIe","1787653578__0__warcM1E-","1787653575__0__xfHVn_A4","1787653583__4__odDUQ0uk","1787653583__1__P9pV7KM3","1787653583__3__VBcCqeA9","1787653583__2__3p0n6PJH","1787653583__0__qKEhUWMN","1787653606__1__jbhHOh0b","1787653566__0__oj-7yFnP","1787653566__1__2hRg-y2j","1787653566__0__BgNwWK-r","1787653566__1__R2zVo-VZ","1787653565__0__hW2cROlp","1787653565__1__XTmXJPSB","1787653559__0__0fEPaYGq","1787653559__1__OWam8L2q","1787653559__0__zJjx8I-3"];
  function isRemoved(src) {
    for (var i = 0; i < REMOVED.length; i++) {
      if (src.indexOf(REMOVED[i]) !== -1) return true;
    }
    return false;
  }
  /* The box to pull is the smallest wrapper that exists only for this photo:
     climb out of the <img> through media/frame wrappers holding exactly one
     image and stop at the first shared container. The old `closest` matched
     the media-strip <img class="jm-media-grid__image"> against ITSELF, so only
     the image left and its 100x100 tile stayed behind as a blank square —
     that is what "the photos aren't loading" actually was (2026-08-27: the
     Doona sun cover showed 7 empty tiles, every photo on it having been
     culled; Baby Trend Expedition Double showed 5). */
  function cullBox(img) {
    var el = img;
    while (el.parentElement) {
      var p = el.parentElement;
      var cn = p.className;
      if (typeof cn !== 'string' || !/jm-media|jm-frame/.test(cn)) break;
      if (p.querySelectorAll('img').length !== 1) break;
      el = p;
    }
    return el;
  }

  /* Pulling the last photo out of a review's photo row leaves wrappers that
     still hold vertical space. Drop whatever the removal just emptied. */
  function pruneEmpty(el) {
    for (var i = 0; i < 4 && el && el.parentElement; i++) {
      if (el.matches && el.matches('.jm-review-item, .jm-review-widget, .jm-media-grid__container, body')) return;
      if (el.children.length || (el.textContent || '').trim()) return;
      var up = el.parentElement;
      up.removeChild(el);
      el = up;
    }
  }

  /* Strips whose every tile was culled (the Doona case). Hidden rather than
     removed so Judge.me's Vue tree stays intact through re-renders; the
     sweep below re-hides after each one. */
  var touched = [];
  function tidy() {
    for (var i = touched.length - 1; i >= 0; i--) {
      var strip = touched[i];
      if (!strip.isConnected) { touched.splice(i, 1); continue; }
      var grid = strip.querySelector('.jm-media-grid__container');
      if (grid && !grid.querySelector('.jm-media-grid__item')) strip.style.display = 'none';
      else strip.style.removeProperty('display');
    }
  }

  function cull(img) {
    var src = img.currentSrc || img.src || '';
    if (src.indexOf('review-images.judgeme.com') === -1 || !isRemoved(src)) return false;
    var strip = img.closest ? img.closest('.jm-media-preview') : null;
    var box = cullBox(img);
    var parent = box.parentElement;
    if (!parent) return false;
    parent.removeChild(box);
    pruneEmpty(parent);
    if (strip && touched.indexOf(strip) === -1) touched.push(strip);
    return true;
  }

  function amazonUrl(src, size) {
    var m = src.match(AMZ_ID);
    if (!m) return null;
    return 'https://m.media-amazon.com/images/I/' + (MAP[m[1]] || m[1]) + '._SL' + size + '_.jpg';
  }

  var SIZES = [320, 480, 640, 800, 1000, 1280, 1600];
  function snap(px) {
    for (var i = 0; i < SIZES.length; i++) if (px <= SIZES[i]) return SIZES[i];
    return 1600;
  }

  /* Device pixels the square thumbnail box actually has to fill. */
  function boxPx(img) {
    var css = Math.max(img.clientWidth || 0, img.clientHeight || 0) || 160;
    return css * (window.devicePixelRatio || 1);
  }

  /* Amazon's _SL sizes cap the LONG side, but the thumbnail is a square crop,
     so it's the photo's SHORT side that has to cover the box — a tall photo
     asked for at _SL320_ arrives 240 wide and lands soft again. Start from a
     4:3 guess, then step up once if the file that came back is shaped such
     that the crop fell short. Only the taller in-card photos ever pay for the
     second request; the 100px strip tiles are satisfied on the first. */
  function swap(img, cdnSrc, url, size, needShort, fallback) {
    var probe = new Image();
    probe.onload = function () {
      var short = Math.min(probe.naturalWidth, probe.naturalHeight);
      if (needShort && short && short < needShort && size < 1600) {
        var bigger = snap(size * (needShort / short));
        var next = bigger > size ? amazonUrl(cdnSrc, bigger) : null;
        if (next) { swap(img, cdnSrc, next, bigger, 0, fallback); return; }
      }
      if (probe.naturalWidth < 120) { img.src = fallback; return; }
      img.removeAttribute('srcset');
      img.src = url;
    };
    probe.onerror = function () { img.src = fallback; };
    probe.src = url;
  }

  function upgrade(img, lightbox) {
    if (img.dataset.jarvisUpscaled) return;
    var src = img.currentSrc || img.src || '';
    if (src.indexOf('review-images.judgeme.com') === -1) return;
    var needShort = lightbox ? 0 : boxPx(img);
    var size = lightbox ? 1600 : snap(needShort * 4 / 3);
    var full = amazonUrl(src, size);
    if (!full) return;
    img.dataset.jarvisUpscaled = '1';
    swap(img, src, full, size, needShort, img.src);
  }

  /* Cull applies to every Judge.me review image anywhere. Upgrades now apply
     everywhere too (2026-08-27): the lightbox still gets the _SL1600_ original,
     and thumbnails get a size-matched copy instead of the 88px import artifact
     they were stretching 2-3x. Cull runs BEFORE upgrade so a removed photo can
     never escape by having its src swapped first. */
  function sweep(root) {
    (root.querySelectorAll ? root.querySelectorAll('img') : []).forEach(function (img) {
      var src = img.currentSrc || img.src || '';
      if (src.indexOf('review-images.judgeme.com') === -1) return;
      if (cull(img)) return;
      upgrade(img, !!(img.closest && img.closest('.jdgm-modal__container')));
    });
    tidy();
  }

  new MutationObserver(function (muts) {
    muts.forEach(function (mu) {
      mu.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('img') && n.parentElement) sweep(n.parentElement);
        else sweep(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState !== 'loading') sweep(document);
  else document.addEventListener('DOMContentLoaded', function () { sweep(document); });
})();
